import styled from 'styled-components';

export const Footer = styled.footer`
  width: 100%;
  margin-top: 16px;
  padding: 24px 16px;
  background-color: ${({ theme }) => theme.custom?.badgeBackground || '#f1f1f1'};
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: ${({ theme }) => theme.custom?.tertiary || '#919191'};
`;

export const Text = styled.p`
  max-width: 430px;
  margin: 0 auto;
  white-space: pre-line;

  a {
    color: inherit;
  }

  & + & {
    margin-top: 16px;
  }
`;

export const Links = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 16px;
`;

export const Link = styled.button`
  padding: 0;
  border: none;
  background: none;
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline;
  color: ${({ theme }) => theme.custom?.secondary || '#444343'};
  cursor: pointer;
`;
